module.exports = __webpack_public_path__ + "static/media/fees-logo-white.cdca1bf5.svg";